const config = {
  getApiUrl: () => 'https://app.tickmark-software.com',
};

export default config;
